import { brandRFMProfileApi } from "../api/brandRFMProfileApi";
import { BrandRFMProfile } from "../models/brandRFMProfile";
import { getToken } from "../utils/getToken";

export const brandRFMProfileService = {
  getBrandRFMProfile: async (
    brandId: string
  ): Promise<BrandRFMProfile[] | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandRFMProfileApi.getBrandRFMProfile(
          token,
          brandId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch brand RFM Profile: ", error);
      return null;
    }
  },
  listBrandRFMProfile: async (brandId: string): Promise<any> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandRFMProfileApi.listBrandRFMProfile(
          token,
          brandId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch brand RFM Profile: ", error);
      return null;
    }
  },
  getBrandRFMProfileById: async (
    brandId: string,
    profileId: number
  ): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandRFMProfileApi.getBrandRFMProfileById(
          token,
          brandId,
          profileId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch brand RFM Profile: ", error);
      return null;
    }
  },
  createBrandRFMProfile: async (
    profile: BrandRFMProfile
  ): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (profile) {
        const response = await brandRFMProfileApi.createBrandRFMProfile(
          token,
          profile
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to create brand RFM Profile: ", error);
      return null;
    }
  },
  updateBrandRFMProfile: async (
    profile: BrandRFMProfile
  ): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (profile) {
        const response = await brandRFMProfileApi.updateBrandRFMProfile(
          token,
          profile
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to update brand RFM Profile: ", error);
      return null;
    }
  },
  setDefaultBrandRFMProfile: async (
    profile: BrandRFMProfile
  ): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (profile) {
        const response = await brandRFMProfileApi.setDefaultBrandRFMProfile(
          token,
          profile
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to set default brand RFM Profile: ", error);
      return null;
    }
  },
  activateBrandRFMProfile: async (
    profileId: number
  ): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (profileId) {
        const response = await brandRFMProfileApi.activateBrandRFMProfile(
          token,
          profileId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to activate brand RFM Profile: ", error);
      return null;
    }
  },
  deleteBrandRFMProfile: async (profileId: number): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (profileId) {
        const response = await brandRFMProfileApi.deleteBrandRFMProfile(
          token,
          profileId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to delete brand RFM Profile: ", error);
      return null;
    }
  },
};
